import { Link } from "react-router-dom";

const NavBar = () => {
    return ( 
        <ul>
        <li>
          <Link to="/aneeqayusafportfolio/projects">Projects</Link>
        </li>
        <li>
          <Link to="/aneeqayusafportfolio/contact">Contact</Link>
        </li>
      </ul>
     );
}


 
export default NavBar;